import React from 'react';
import { useTranslation } from 'react-i18next';

import GenericPaymentMethod from './GenericPaymentMethod';
import Trans from 'components/Common/Translation/Trans';
import PaymentMethod from 'model/PaymentMethod';
import { apiUrls } from 'services/api-urls';
import { MethodProps } from 'types/PaymentFormType';

import QELogo from 'assets/img/Payment/4etoiles.svg';

import styles from './PaymentMethod.module.scss';

const QePaymentMethod = ({
  handleClick,
  isSelected,
  setPaymentMethod,
}: MethodProps): JSX.Element | null => {
  const { t } = useTranslation(['checkout']);

  return (
    <GenericPaymentMethod
      value={PaymentMethod.qe}
      onClick={() => {
        void setPaymentMethod(PaymentMethod.qe);
      }}
      classes={{
        methodTitle: styles.qeMethodTitle,
      }}
      labelContent={
        <>
          <span className={styles.methodLogo}>
            <img src={QELogo} alt={'Four stars logo'} />
          </span>
          <span className={styles.methodText}>{t('QE_METHOD_TITLE')}</span>
        </>
      }
    >
      {isSelected && (
        <div className={styles.qeMethodContentContainer}>
          <Trans
            i18nKey={'QE_METHOD_INFORMATION'}
            namespace={'checkout'}
            additionalComponents={{
              learnMore: (
                <a
                  className={styles.seeMore}
                  href={apiUrls.getMediaPopin('/16.html')}
                  onClick={handleClick}
                />
              ),
            }}
          />
        </div>
      )}
    </GenericPaymentMethod>
  );
};

export default QePaymentMethod;
